
import { Separator } from "@/components/ui/separator";
import { LeadContact } from "@/services/leadContactsService";
import ContactsFilter from "@/components/contacts/ContactsFilter";
import ContactsList from "@/components/contacts/ContactsList";
import ContactsTable from "@/components/contacts/ContactsTable";
import ContactDetail from "@/components/contacts/ContactDetail";
import { DataPagination } from "@/components/ui/data-pagination";

interface ContactsContentProps {
  viewMode: "card" | "list" | "details";
  selectedContact: LeadContact | null;
  filteredContacts: LeadContact[];
  paginatedContacts: LeadContact[];
  searchQuery: string;
  onSearchChange: (value: string) => void;
  departmentFilter: string;
  onDepartmentChange: (department: string) => void;
  departments: string[];
  isLoading: boolean;
  error: string | null;
  onAddContact: () => void;
  onEditContact: (contact: LeadContact) => void;
  onViewContact: (contact: LeadContact) => void;
  onDeleteContact: (contact: LeadContact) => void;
  onContactUpdated: () => void;
  onBack: () => void;
  onInitiateCall?: (contact: LeadContact) => void;
  // Pagination props
  currentPage: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

const ContactsContent = ({
  viewMode,
  selectedContact,
  filteredContacts,
  paginatedContacts,
  searchQuery,
  onSearchChange,
  departmentFilter,
  onDepartmentChange,
  departments,
  isLoading,
  error,
  onAddContact,
  onEditContact,
  onViewContact,
  onDeleteContact,
  onContactUpdated,
  onBack,
  onInitiateCall,
  currentPage,
  pageSize,
  totalItems,
  totalPages,
  onPageChange,
  onPageSizeChange
}: ContactsContentProps) => {
  console.log('🔍 ContactsContent Debug:', {
    viewMode,
    filteredContactsLength: filteredContacts.length,
    paginatedContactsLength: paginatedContacts.length,
    isLoading,
    error
  });
  
  return (
    <>
      {/* Only show filters if not in details view */}
      {viewMode !== "details" && (
        <>
          <ContactsFilter 
            searchQuery={searchQuery}
            onSearchChange={onSearchChange}
            departmentFilter={departmentFilter}
            onDepartmentChange={onDepartmentChange}
            departments={departments}
          />
          
          <Separator />
        </>
      )}
      
      {/* Different view modes */}
      {viewMode === "details" && selectedContact ? (
        <ContactDetail 
          contact={selectedContact} 
          onEdit={onEditContact}
          onBack={onBack}
          onInitiateCall={onInitiateCall}
        />
      ) : viewMode === "card" ? (
        <ContactsList 
          contacts={filteredContacts}
          isLoading={isLoading}
          error={error}
          searchQuery={searchQuery}
          departmentFilter={departmentFilter}
          onAddContact={onAddContact}
          onEditContact={onEditContact}
          onViewContact={onViewContact}
          onDeleteContact={onDeleteContact}
          onInitiateCall={onInitiateCall}
        />
      ) : (
        <div className="space-y-4">
          <ContactsTable 
            contacts={paginatedContacts} 
            onContactUpdated={onContactUpdated}
            onEditContact={onEditContact}
            onViewContact={onViewContact}
            onDeleteContact={onDeleteContact}
            onInitiateCall={onInitiateCall}
            isLoading={isLoading}
          />
          
          {/* Add pagination - only show for list view mode and when not loading */}
          {viewMode === "list" && !isLoading && totalPages > 1 && (
            <DataPagination
              currentPage={currentPage}
              totalPages={totalPages}
              pageSize={pageSize}
              totalItems={totalItems}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
              pageSizeOptions={[10, 25, 50, 100]}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ContactsContent;
